export class Tool {
	constructor({ mode, name, cursor, className, supported = true, store }) {
		/** @type {string} */
		this.mode = mode;

		/** @type {string} */
		this.name = name;

		/** @type {string} */
		this.cursor = cursor || 'default';

		/** @type {string} */
		this.className = className;

		/** @type {boolean} */
		this.supported = supported;

		/**
		 * @typedef {{ getState: () => any; setState: (state) => any }} Store
		 *
		 * @type {Store}
		 * */
		this.store = store;
	}

	/**
	 * @abstract
	 * 工具被激活时调用，此时可以进行工具状态的初始化
	 */
	onActived() {
		throw new Error('Tool.onActived() is abstract');
	}

	/**
	 * @abstract
	 * 工具接收到用户输入时会被调用，此时需要根据用户的输入来给出当前工具生成的图形以及图形是否已经完成
	 */
	onInput() {
		throw new Error('Tool.onInput() is abstact');
	}

	/**
	 * 工具被取消激活时调用
	 */
	onDeactived() {
		return { commit: false, drawing: null };
	}

	/**
	 * 渲染工具生成的图形到 Canvas 上
	 */
	onRenderCanvas() {}

	/**
	 * 渲染工具生成的图形为 React 元素
	 */
	onRenderElement() {}
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/Tool.js